import { Link, useNavigate } from "react-router-dom";
import { Wand2, Plus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import useMuses from "@/hooks/useMuses";
import ThisWeek from "@/components/ThisWeek";
import MuseCard from "@/components/MuseCard";
import MuseCollage from "@/components/MuseCollage";

const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
};

export default function Home() {
  const { user } = useAuth();
  const nav = useNavigate();
  const { muses, example, loading } = useMuses();
  const all = [...muses, ...(example ? [example] : [])];
  return (
    <div>
      <section className="panel overflow-hidden mb-10 flex flex-col sm:flex-row sm:items-center gap-5 p-4 sm:p-5 fade-up" data-testid="home-welcome-banner">
        <div className="h-[180px] bg-[#EFE9E1] rounded-[16px] p-3 overflow-hidden shrink-0 max-w-full"><MuseCollage compact /></div>
        <p className="font-display text-3xl sm:text-4xl px-1">Welcome back —<br /><span className="accent-text">let's make her famous.</span></p>
      </section>
      <section className="fade-up">
        <p className="eyebrow mb-3">{greeting()}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl " data-testid="home-greeting">
          {user.name?.split(" ")[0]}, your muses<br /><span className="accent-text">are waiting.</span>
        </h1>
        <button
          className="btn-primary w-full sm:w-auto mt-10 py-5 px-10 text-sm"
          onClick={() => nav("/create")}
          data-testid="home-create-content-button"
        >
          <Wand2 size={18} /> Create content
        </button>
      </section>
      <ThisWeek />
      <section className="mt-16">
        <div className="flex items-end justify-between mb-6">
          <h2 className="text-base md:text-lg font-display">Your roster</h2>
          <Link to="/muses" className="text-xs uppercase tracking-[0.15em] text-[#9C4DDC]" data-testid="home-view-all-muses-link">View all</Link>
        </div>
        {loading ? <p className="muted text-sm">Loading…</p> : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
            {all.map((m, i) => <MuseCard key={m.id} muse={m} index={i} />)}
            {muses.length === 0 && (
              <Link to="/muses/new" className="panel border-dashed aspect-[4/5] flex flex-col items-center justify-center gap-3 hover:border-[#9C4DDC] transition-colors" data-testid="home-new-muse-tile">
                <Plus className="text-[#9C4DDC]" strokeWidth={1.25} size={32} />
                <span className="text-xs uppercase tracking-[0.15em] muted">Create your first muse</span>
              </Link>
            )}
          </div>
        )}
      </section>
    </div>
  );
}
